import React, {ComponentType, createContext, FC, useContext} from 'react';
import {Diff} from 'utility-types';

/*
 * Props.
 */

export interface VariableHeightContextProps {
  onHeightChange?(previousHeight: number, newHeight: number): void;
  onElementLoaded(): void;
}

/*
 * Context.
 */

export const VariableHeightContext = createContext<VariableHeightContextProps>({
  onHeightChange: undefined,
  onElementLoaded: () => {},
});

/*
 * HOC.
 */

export function withVariableHeight<T extends object>(
  Component: ComponentType<T & VariableHeightContextProps>,
): FC<Diff<T, VariableHeightContextProps>> {
  return function WithVariableHeight(props) {
    return (
      <VariableHeightContext.Consumer>
        {(context) => <Component {...(props as any)} {...context} />}
      </VariableHeightContext.Consumer>
    );
  };
}

/*
 * Hook.
 */

export function useVariableHeightContext() {
  return useContext(VariableHeightContext);
}
